var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "flex-level tabs-list" },
    _vm._l(_vm.tabs, function(tab, tabIndex) {
      return _c(
        "li",
        {
          key: tabIndex,
          staticClass: "flex-row px-3 py-2 fs-3 tab-item",
          class: { "tab-item--active": tab.id === _vm.activeTab },
          on: {
            click: function($event) {
              return _vm.$emit("tab-clicked", tab.id)
            }
          }
        },
        [_vm._v("\n        " + _vm._s(tab.label) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }